import React from 'react'
import './AboutStyles.css'

const About = () => {
  return (
    <div className="about">
        <div className="left">
            <h1>Who we are:</h1>
            <p>For Auto Repair, Dorchester and Roslindale residents can count on Belgrade for automotive services. The auto mechanics here are ready to tackle any auto repair or maintenance your vehicle may need. We will properly maintain or repair your car to keep it on the road instead of the repair shop. You rely heavily on your vehicle for commuting and running errands so keep your car properly maintained!</p>
        </div>
        <div className="right">
            <img src="https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1932&q=80" alt="" />
        </div>
    </div>
  )
}

export default About